import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  Calendar,
  List,
  Modal,
  Button,
  Input,
  Row,
  Col,
  Typography,
  Upload,
  TimePicker,
  message,
  Popconfirm,
  Checkbox,
  Select,
  Radio,
} from "antd";
import {
  UploadOutlined,
  PlusOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import moment from "moment";
import dataService from "../networks/api/service/dataService";
import colors from "../assets/styles/colour";
import DynamicExcelUpload from "../components/DynamicExcelUpload";
// import { fetchEvents, addEvent, updateEvent, deleteEvent } from "./Api"; // Import the API functions

const EventEntryPage = () => {
  const [selectedDate, setSelectedDate] = useState(moment());
  const [events, setEvents] = useState({});
  const [eventData, setEventData] = useState({
    name: "",
    startTime: null,
    endTime: null,
    description: "",
    image: null,
    organizer: "",
    phoneNumber: null,
    refferedPerson: "",
    eventType: null,
    priority: "",
  });
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [isModalVisible, setModalVisible] = useState(false);
  const [activeView, setActiveView] = useState("daily");
  const [activeMonth, setActiveMonth] = useState(moment().format("YYYY-MM"));
  const [selectedEventId, setSelectedEventId] = useState(null); // To store the ID of the event being updated
  const UserRole = localStorage.getItem("UserRole");
  const listRef = useRef(null);
  const [openPopconfirmId, setOpenPopconfirmId] = useState(null);
  const [holidays, setHolidays] = useState([]);

  const location = useLocation();

  const { value: navigationValue } = location.state || {};

  console.log(navigationValue, "navigatfghj");

  const [selectedEventType, setSelectedEventType] = useState(
    navigationValue || null
  );

  const { Option } = Select;

  const [selectedPriority, setSelectedPriority] = useState(null);
  const [priority, setPriority] = useState("important");
  const eventTypeColors = {
    appointment: "#FFD1D1", // Light Red (soft pink)
    event: "#FFEDB5", // Light Orange (soft yellow)
    specialDay: "#D6E4FF", // Light Blue
    default: "#E6E6FA", // Fallback Light Lavender
  };
  // const holidays = [
  //   { date: "2024-12-25", name: "Christmas Day" },
  //   { date: "2025-08-15", name: "Independence Day" },
  //   { date: "2025-01-01", name: "New Year's Day" },
  //   { date: "2025-01-14", name: "Makar Sankranti" },
  // ];

  const handleTimeChange = (field, time) => {
    const formattedTime = time ? time.format("h:mm A") : null;

    setEventData((prevData) => {
      // If the new time is the same as the other field, show an error and do nothing
      if (
        (field === "startTime" && formattedTime === prevData.endTime) ||
        (field === "endTime" && formattedTime === prevData.startTime)
      ) {
        message.error("Start time and end time cannot be the same!");
        return prevData; // Do not update state
      }

      console.log(`Updating ${field} to`, formattedTime);
      return {
        ...prevData,
        [field]: formattedTime,
      };
    });
  };

  const loadEvents = async () => {
    let payload;
    let formattedDate = selectedDate.clone();

    if (activeView === "monthly") {
      formattedDate = formattedDate.startOf("month");
      payload = {
        month: formattedDate.month() + 1, // month() is zero-based
        year: formattedDate.year(),
      };
    } else {
      payload = {
        eventDate: selectedDate.format("YYYY-MM-DD"),
      };
    }

    try {
      const response = await dataService.fetchEvents(activeView, payload);
      console.log("filteredEvents events", response.data);

      if (response.code === 200) {
        setFilteredEvents(response.data); // Assuming no filters for now
        const eventList = response.data;

        const eventsByDate = eventList.reduce((acc, event) => {
          const date = moment(event.eventDate, [
            "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ",
            "YYYY-MM-DD",
          ]).format("YYYY-MM-DD");
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push(event);
          return acc;
        }, {});

        setEvents(eventsByDate);
      } else {
        setFilteredEvents([]);
      }
    } catch (error) {
      setFilteredEvents([]);

      console.error("Error fetching events:", error);
      message.error("Failed to fetch events.");
    }
  };

  useEffect(() => {
    loadEvents();
  }, [selectedDate, activeView]);

  useEffect(() => {
    const handleScroll = () => {
      setOpenPopconfirmId(null); // Close Popconfirm on scroll
    };

    const divElement = listRef.current;
    if (divElement) {
      divElement.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (divElement) {
        divElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const renderDateCell = (value) => {
    const dateStr = value.format("YYYY-MM-DD");

    // Check if the date has events
    const hasEvents = events[dateStr] && events[dateStr].length > 0;

    // Check if the date is a holiday
    const isHoliday = holidays.some((holiday) => holiday.date === dateStr);

    // Render custom content for dates with events or holidays
    // return (
    //   <div>
    //     <div>{value.date()}</div>
    //     {hasEvents && <div style={{ color: "blue" }}>📅</div>}
    //     {isHoliday && <div style={{ color: "red" }}>🎉</div>}
    //   </div>
    // );
  };

  const handleDateSelect = (date) => {
    setSelectedDate(date);
  };

  const handleAddEvent = async () => {
    const {
      name,
      startTime,
      endTime,
      description,
      organizer,
      phoneNumber,
      refferedPerson,
      eventType,
      priority,
    } = eventData;

    // Validate mandatory fields
    if (!name || !startTime || !endTime || !description) {
      message.error("Please fill in all required fields.");
      return;
    }

    // Validate that start time and end time are not the same
    if (startTime === endTime) {
      message.error("Start time and end time cannot be the same!");
      return; // Prevent event creation
    }

    console.log(startTime, "startTime");
    const eventTime = `${startTime} - ${endTime}`;
    const newEvent = {
      eventName: name,
      eventDescription: description,
      eventTime: eventTime,
      eventDate: selectedDate.format("YYYY-MM-DD"),
      eventOrganizer: organizer,
      eventType: eventType, // Add eventType
      priority: priority, // Add priority
      phoneNumber: phoneNumber,
      refferedPerson: refferedPerson,
    };

    try {
      const response = await dataService.addEvent(newEvent); // Use the addEvent API
      if (response.code === 200) {
        const updatedEvents = {
          ...events,
          [selectedDate.format("YYYY-MM-DD")]: [
            ...(events[selectedDate.format("YYYY-MM-DD")] || []),
            { ...newEvent, _id: response.data._id }, // Assign _id from API response
          ],
        };
        setEvents(updatedEvents);

        // Reset form data
        setEventData({
          name: "",
          startTime: "",
          endTime: "",
          description: "",
          image: null,
          organizer: "",
          phoneNumber: "",
          refferedPerson: "",
          eventTime: "",
          priority: "",
        });
        setModalVisible(false);
        message.success("Event added successfully!");
      } else {
        message.error("Failed to add event.");
      }
    } catch (error) {
      console.error("Error adding event:", error);
      message.error("Failed to add event.");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    //   setEventData((prevData) => ({
    //     ...prevData,
    //     [name]: value,  // Updates only the relevant field
    //   }));
    // };

    let isValid = true;

    if (name === "name" || name === "organizer" || name === "refferedPerson") {
      isValid = /^[A-Za-z\s]*$/.test(value); // Allow only letters and spaces
    } else if (name === "phoneNumber") {
      isValid = /^[0-9]{0,10}$/.test(value); // Allow only numbers, max 10 digits
    }

    if (isValid) {
      setEventData((prevData) => ({
        ...prevData,

        [name]: value, // Updates only the relevant field
      }));
    }
  };

  const handleImageUpload = (info) => {
    setEventData({ ...eventData, image: info.file });
  };

  const shareEventDetails = () => {
    if (!events[selectedDate.format("YYYY-MM-DD")]?.length) {
      message.warning("No events to share!");
      return;
    }

    const eventDetails = events[selectedDate.format("YYYY-MM-DD")]
      .map(
        (event) =>
          `${event.name},(${event.startTime} - ${event.endTime})\nDescription: ${event.description},\nOrganizer: ${event.organizer},\nOrganizer Mobile No: ${event.phoneNumber},\nReffered Person: ${event.refferedPerson}\nType: ${event.eventType},\nPriority: ${event.priority}`
      )
      .join("\n\n");

    message.success("Event details prepared for sharing!");
    console.log("Share Event Details:\n" + eventDetails);
  };

  const filterEvents = () => {
    const selectedMoment = selectedDate;
    const eventDates = Object.keys(events);
    const filteredEvents = [];

    eventDates.forEach((date) => {
      const eventMoment = moment(date);

      if (activeView === "daily" && eventMoment.isSame(selectedMoment, "day")) {
        filteredEvents.push(...events[date]);
      } else if (
        activeView === "weekly" &&
        eventMoment.isBetween(
          selectedMoment.clone().startOf("week"),
          selectedMoment.clone().endOf("week"),
          null,
          "[]"
        )
      ) {
        filteredEvents.push(...events[date]);
      } else if (
        activeView === "monthly" &&
        eventMoment.isSame(selectedMoment, "month") // ✅ Corrected month comparison
      ) {
        console.log("Monthly Event Found:", events[date]); // ✅ Debug log
        filteredEvents.push(...events[date]);
      } else if (
        activeView === "yearly" &&
        eventMoment.isSame(selectedMoment, "year")
      ) {
        filteredEvents.push(...events[date]);
      }
    });

    return filteredEvents;
  };

  const handleDeleteEvent = async (eventId) => {
    try {
      const response = await dataService.deleteEvent(eventId); // Call the delete API with eventId
      if (response.code === 200) {
        // Update the `events` state
        const updatedEvents = { ...events };
        Object.keys(updatedEvents).forEach((date) => {
          updatedEvents[date] = updatedEvents[date].filter(
            (event) => event._id !== eventId
          );
        });
        setEvents(updatedEvents);

        // Update the `filteredEvents` state
        const updatedFilteredEvents = filteredEvents.filter(
          (event) => event._id !== eventId
        );
        setFilteredEvents(updatedFilteredEvents);

        message.success("Event deleted successfully!");
      } else {
        message.error("Failed to delete the event.");
      }
    } catch (error) {
      console.error("Error deleting event:", error);
      message.error("Failed to delete the event.");
    }
  };

  const confirmDelete = (eventId) => {
    handleDeleteEvent(eventId);
  };

  const cancelDelete = () => {
    message.info("Delete action cancelled");
  };

  const handleUpdateEvent = (event) => {
    console.log(event, "event");
    const [startTime, endTime] = event.eventTime.split(" - ");

    setEventData({
      name: event.eventName,
      startTime: startTime.trim(),
      endTime: endTime.trim(),
      description: event.eventDescription,
      image: event.image || null,
      organizer: event.eventOrganizer,
      organizerMobileNo: event.phoneNumber,
      refferedPerson: event.refferedPerson,
      eventType: event.eventType || "", // Ensure eventType is set or empty
      priority: event.priority || "important", // Default to "important"
    });
    setSelectedEventId(event._id); // Set the event ID for the update
    setModalVisible(true); // Open the modal
  };

  const handleSaveUpdatedEvent = async () => {
    console.log("Final eventData before saving:", eventData); // Debugging log

    const {
      name,
      organizer,
      OrganizerMobileNo,
      refferedPerson,
      description,
      eventType,
      priority,
    } = eventData;

    if (!name || !description) {
      message.error("Please fill in all required fields.");
      return;
    }

    const updatedEvent = {
      eventName: name,
      eventDescription: description,
      eventOrganizer: organizer,
      eventOrganizerMobileNo: OrganizerMobileNo,
      refferedPerson: refferedPerson,
      eventDate: selectedDate.format("YYYY-MM-DD"),
      eventType,
      priority,
      image: eventData.image,
    };

    console.log("Payload sent to API:", updatedEvent); // Debugging log

    try {
      const response = await dataService.updateEvent(
        selectedEventId,
        updatedEvent
      );
      console.log("API Response:", response.data); // Debugging log

      if (response.code === 200) {
        // Update state correctly
        const updatedEvents = { ...events };
        Object.keys(updatedEvents).forEach((date) => {
          updatedEvents[date] = updatedEvents[date].map((event) =>
            event._id === selectedEventId
              ? { ...event, ...updatedEvent }
              : event
          );
        });

        setEvents(updatedEvents);
        message.success("Event updated successfully!");
        setModalVisible(false);
      } else {
        message.error("Failed to update event.");
      }
    } catch (error) {
      console.error("Error updating event:", error);
      message.error("Failed to update event.");
    }
  };

  const filteredEventsByTypeAndPriority = filteredEvents.filter((event) => {
    return (
      (!selectedEventType || event.eventType === selectedEventType) &&
      (!selectedPriority || event.priority === selectedPriority)
    );
  });

  const handleShare = () => {
    const selectedEvent = events[selectedDate.format("YYYY-MM-DD")];

    if (!selectedEvent || selectedEvent.length === 0) {
      message.warning("No events available to share!");
      return;
    }

    // Format the event details
    const eventDetails = selectedEvent
      .map(
        (event) =>
          `${event.name},(${event.startTime} - ${event.endTime})\nDescription: ${event.description},\nOrganizer: ${event.organizer},\nOrganizer Mobile No: ${event.phoneNumber},\nReffered Person: ${event.refferedPerson}`
      )
      .join("\n\n");

    // Share via WhatsApp (URL encoding event details)
    const whatsappMessage = encodeURIComponent(eventDetails);
    const whatsappUrl = `https://wa.me/?text=${whatsappMessage}`;

    // Share via email (mailto link with event details)
    const emailSubject = encodeURIComponent("Event Details");
    const emailBody = encodeURIComponent(eventDetails);
    const emailUrl = `mailto:?subject=${emailSubject}&body=${emailBody}`;

    // Open share options
    const shareOptions = (
      <div>
        <Button
          type="link"
          href={whatsappUrl}
          target="_blank"
          icon={
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a3/WhatsApp.svg/1200px-WhatsApp.svg.png"
              alt="WhatsApp"
              width="20px"
            />
          }
        >
          Share on WhatsApp
        </Button>
        <br />
        <Button
          type="link"
          href={emailUrl}
          target="_blank"
          icon={
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/e/e7/Mail_icon.svg"
              alt="Email"
              width="20px"
            />
          }
        >
          Share via Email
        </Button>
      </div>
    );

    // Display options using Ant Design Popover
    Modal.info({
      title: "Share Event Details",
      content: shareOptions,
      onOk() {},
    });
  };
  const resetForm = () => {
    setEventData({
      name: "",
      startTime: "",
      endTime: "",
      organizer: "",
      OrganizerMobileNo: "",
      refferedPerson: "",
      description: "",
      eventType: "",
      priority: "",
      image: null,
    });
    setSelectedEventId(null);
  };

  const renderEventList = () => {
    // const filteredEvents = filterEvents(); // Get the events based on the selected view
    console.log(filteredEvents, "filteredEvents", events);
    return (
      <div
        style={{
          padding: "20px",
          marginBottom: "20px",
          boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
          borderRadius: "8px",
          backgroundColor: "#fff",
          overflowY: "auto",
          maxHeight: "60vh",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <h3 style={{ fontSize: "1.5em" }}>
            Events ({activeView.charAt(0).toUpperCase() + activeView.slice(1)})
          </h3>
          <div
            style={{
              gap: "10px",
              display: UserRole === "ADMIN" ? "flex" : "none",
            }}
          >
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setModalVisible(true)}
              style={{ backgroundColor: colors.buttoSecondary }}
            >
              Add Event
            </Button>
            <Button
              type="primary"
              icon={<ShareAltOutlined />}
              onClick={handleShare}
              style={{ backgroundColor: colors.buttoSecondary }}
            >
              Share Event
            </Button>
          </div>
        </div>
        <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
          <Button
            type="default"
            onClick={() => setActiveView("daily")}
            style={{
              backgroundColor:
                activeView === "daily" ? colors.buttoSecondary : "transparent",
              color: activeView === "daily" ? "#fff" : "#000",
              borderColor:
                activeView === "daily" ? colors.buttoSecondary : "#d9d9d9",
            }}
          >
            Daily
          </Button>
          <Button
            type="default"
            onClick={() => setActiveView("weekly")}
            style={{
              backgroundColor:
                activeView === "weekly" ? colors.buttoSecondary : "transparent",
              color: activeView === "weekly" ? "#fff" : "#000",
              borderColor:
                activeView === "weekly" ? colors.buttoSecondary : "#d9d9d9",
            }}
          >
            Weekly
          </Button>
          <Button
            type="default"
            onClick={() => setActiveView("monthly")}
            style={{
              backgroundColor:
                activeView === "monthly"
                  ? colors.buttoSecondary
                  : "transparent",
              color: activeView === "monthly" ? "#fff" : "#000",
              borderColor:
                activeView === "monthly" ? colors.buttoSecondary : "#d9d9d9",
            }}
          >
            Monthly
          </Button>
          <Select
            placeholder="Filter by Event Type"
            onChange={(value) => setSelectedEventType(value)}
            style={{ width: "120px" }}
            value={selectedEventType}
            allowClear
          >
            {[...new Set(filteredEvents.map((event) => event.eventType))].map(
              (type) => (
                <Option key={type} value={type}>
                  {type}
                </Option>
              )
            )}
          </Select>

          <Select
            placeholder="Filter by Priority"
            onChange={(value) => setSelectedPriority(value)}
            style={{ width: "120px" }}
            allowClear
          >
            {[...new Set(filteredEvents.map((event) => event.priority))].map(
              (priority) => (
                <Option key={priority} value={priority}>
                  {priority}
                </Option>
              )
            )}
          </Select>
        </div>

        <div
          ref={listRef}
          style={{
            maxHeight: "300px", // Adjust this to set the maximum height
            overflowY: "auto", // Enables scrolling when content exceeds maxHeight
            border: "1px solid #f0f0f0",
            borderRadius: "8px",
            padding: "10px",
          }}
        >
          <List
            size="small"
            dataSource={filteredEventsByTypeAndPriority}
            renderItem={(event, index) => (
              <List.Item
                key={event._id}
                style={{
                  backgroundColor:
                    eventTypeColors[event.eventType] || eventTypeColors.default,
                  padding: "15px",
                  borderRadius: "8px",
                  color: "black", // Ensuring text is clearly visible
                  marginBottom: "10px",
                }}
              >
                <div style={{ fontSize: "1.2em" }}>
                  <strong>{event.eventName || "Unnamed Event"}</strong>
                  <div>
                    <strong>Time:</strong> {event.eventTime || "Unknown Time"}
                  </div>
                  <div>
                    <strong>Description:</strong>{" "}
                    {event.eventDescription || "No description provided."}
                  </div>
                  <div>
                    <strong>Organizer:</strong>{" "}
                    {event.eventOrganizer || "No Organizer"}
                  </div>
                  <div>
                    <strong>Organizer Mobile No:</strong>{" "}
                    {event.phoneNumber || "No Mobile Number"}
                  </div>
                  <div>
                    <strong>Referred Person Name:</strong>{" "}
                    {event.refferedPerson || "No reference"}
                  </div>
                  <div>
                    <strong>Type Of Event:</strong>{" "}
                    {event.eventType || "Event type not specified"}
                  </div>
                  <div>
                    <strong>Priority:</strong>{" "}
                    {event.priority || "Priority not set"}
                  </div>
                  <div
                    style={{
                      marginTop: "10px",
                      display: UserRole === "ADMIN" ? "block" : "none",
                    }}
                  >
                    <Button
                      type="primary"
                      onClick={() => handleUpdateEvent(event)}
                    >
                      Update
                    </Button>
                    <Popconfirm
                      title="Are you sure you want to delete this event?"
                      onConfirm={() => confirmDelete(event._id)}
                      onCancel={cancelDelete}
                      okText="Yes"
                      cancelText="No"
                      open={openPopconfirmId === event._id}
                      onOpenChange={(visible) =>
                        setOpenPopconfirmId(visible ? event._id : null)
                      }
                      getPopupContainer={(trigger) => trigger.parentElement}
                    >
                      <Button
                        type="danger"
                        style={{
                          marginLeft: "10px",
                          backgroundColor: "red",
                          color: "white",
                          borderColor: "red",
                        }}
                      >
                        Delete
                      </Button>
                    </Popconfirm>
                  </div>
                </div>
              </List.Item>
            )}
          />
        </div>
      </div>
    );
  };

  const renderHolidayList = () => {
    if (!holidays || !Array.isArray(holidays)) {
      console.error("Holidays is not an array:", holidays);
      return null; // Ensure holidays is an array before filtering
    }

    // ✅ Filter out null, undefined, or missing eventDate before accessing it
    const validHolidays = holidays.filter(
      (holiday) =>
        holiday && holiday.eventDate !== null && holiday.eventDate !== undefined
    );

    const activeMonthHolidays = validHolidays.filter((holiday) => {
      const holidayMonth = moment(holiday.eventDate, "YYYY-MM-DD").format(
        "YYYY-MM"
      );
      return holidayMonth === activeMonth;
    });

    return (
      <>
        <div>
          Bulk upload events :
          <DynamicExcelUpload getExcelData={getExcelData} />
        </div>
        <div
          style={{
            padding: "20px",
            boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
            borderRadius: "8px",
            backgroundColor: "#fff",
            maxHeight: "60vh",
            overflowY: "auto",
          }}
        >
          <h3 style={{ fontSize: "1.5em", marginBottom: "10px" }}>
            Holidays in {activeMonth}
          </h3>
          <List
            size="small"
            bordered
            // dataSource={holidays.filter((holiday) => {
            //   const holidayMonth = moment(
            //     holiday.eventDate,
            //     "YYYY-MM-DD"
            //   ).format("YYYY-MM");
            //   return holidayMonth === activeMonth;
            // })}
            dataSource={activeMonthHolidays}
            key={activeMonth} // Forces re-render when activeMonth changes
            renderItem={(item, index) => (
              <List.Item key={index}>
                <Typography.Text strong>
                  {item?.eventName || "Unknown Holiday"}
                </Typography.Text>{" "}
                ({item?.eventDate || "Invalid Date"})
              </List.Item>
            )}
          />
        </div>
      </>
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && openPopconfirmId === eventData._id) {
      confirmDelete(eventData._id);
      setOpenPopconfirmId(null); // Close Popconfirm after confirmation
    }
  };

  const getExcelData = async (formData) => {
    console.log("Uploading Excel Data...", formData);
    try {
      const res = await dataService.addBulkEvent(formData);

      if (res.code === 200 && res.data) {
        console.log("Uploaded Events:", res.data);

        const formattedHolidays = res.data
          .filter((event) => event && event.eventDate)
          .map((event) => ({
            eventName: event.eventName || "Unknown Holiday",
            eventDate: moment(event.eventDate).format("YYYY-MM-DD"),
          }));

        setHolidays(formattedHolidays);

        localStorage.setItem("holidays", JSON.stringify(formattedHolidays));

        console.log("Formatted Holidays:", formattedHolidays);
      } else {
        message.error("Failed to upload events.");
      }
    } catch (e) {
      console.error("Error uploading file", e);
      message.error("Failed to upload events.");
    }
  };
  useEffect(() => {
    const storedHolidays = localStorage.getItem("holidays");
    if (storedHolidays) {
      setHolidays(JSON.parse(storedHolidays));
    }
  }, []);
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter" && openPopconfirmId) {
        confirmDelete(openPopconfirmId);
        setOpenPopconfirmId(null); // Close the Popconfirm
      }
    };

    if (openPopconfirmId) {
      document.addEventListener("keydown", handleKeyDown);
    } else {
      document.removeEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [openPopconfirmId, confirmDelete]);

  return (
    <div>
      <div
        style={{
          padding: "20px",
          marginBottom: "20px",
          boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
          borderRadius: "8px",
          backgroundColor: "#fff",
          overflowY: "auto",
          maxHeight: "calc(100vh - 200px)", // Adjust calendar height
          position: "relative",
        }}
      >
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <div
              style={{
                position: "sticky",
                top: "0", // Stick to the top of the container
                backgroundColor: "#fff",
                zIndex: 10,
                paddingBottom: "10px", // Add padding to separate it visually
                borderBottom: "1px solid #e8e8e8", // Optional: separator line
              }}
            >
              <Calendar
                onSelect={handleDateSelect}
                // dateCellRender ={renderDateCell}
                style={{ color: colors.save }}
                key={holidays.length}
                onPanelChange={(date) => setActiveMonth(date.format("YYYY-MM"))}
                dateCellRender={(date) => {
                  const formattedDate = date.format("YYYY-MM-DD");

                  const holiday = holidays
                    .filter((h) => h && h.eventDate)
                    .find((h) => h.eventDate === formattedDate);

                  return holiday ? (
                    <div
                      style={{
                        color: "#0c5140",
                        margin: "3px 4px",
                        fontWeight: "lighter",
                        textAlign: "left",
                        fontSize: "10px",
                        fontWeight: "8px",
                        whiteSpace: "wrap",
                      }}
                    >
                      {holiday.eventName}
                    </div>
                  ) : null;
                }}
              />
            </div>
          </Col>
          <Col xs={24} md={12}>
            {renderEventList()}
            {renderHolidayList()}
          </Col>
        </Row>

        <Modal
          title={selectedEventId ? "Update Event" : "Add Event"} // Dynamic title
          open={isModalVisible}
          onCancel={() => {
            setModalVisible(false);
            resetForm(); // Clear the form and state when closing the modal
          }}
          onOk={selectedEventId ? handleSaveUpdatedEvent : handleAddEvent} // Switch function based on context
          okText={selectedEventId ? "Update Event" : "Add Event"} // Dynamic button text
          cancelText="Cancel"
        >
          <Input
            placeholder="Event Name*"
            value={eventData.name}
            name="name"
            onChange={handleInputChange}
            rules={[
              {
                pattern: /^[A-Za-z\s]+$/,
                message: "Only letters and spaces are allowed",
              },
            ]}
            style={{ marginBottom: "10px" }}
          />
          <TimePicker
            placeholder="Start Time*"
            value={
              eventData.startTime ? moment(eventData.startTime, "h:mm A") : null
            }
            onChange={(time) =>
              setEventData({ ...eventData, startTime: time.format("h:mm A") })
            }
            style={{ marginBottom: "10px", width: "100%" }}
            use12Hours
            format="h:mm A"
            disabled={!!selectedEventId} // Disable field during update
          />
          <TimePicker
            placeholder="End Time*"
            value={
              eventData.endTime ? moment(eventData.endTime, "h:mm A") : null
            }
            onChange={(time) =>
              setEventData({ ...eventData, endTime: time.format("h:mm A") })
            }
            style={{ marginBottom: "10px", width: "100%" }}
            use12Hours
            format="h:mm A"
            disabled={!!selectedEventId} // Disable field during update
          />
          <Input
            placeholder="Organizer"
            value={eventData.organizer || ""} // Optional field
            name="organizer"
            onChange={handleInputChange}
            rules={[
              {
                pattern: /^[A-Za-z\s]+$/,
                message: "Only letters and spaces are allowed",
              },
            ]}
            style={{ marginBottom: "10px" }}
          />
          <Input
            placeholder="Organizer Mobile No"
            value={eventData.phoneNumber || ""} // Optional field
            name="phoneNumber"
            onChange={handleInputChange}
            rules={[
              {
                pattern: /^[0-9]{10}$/,
                message: "Please enter exactly 10 digits",
              },
            ]}
            style={{ marginBottom: "10px" }}
          />
          <TextArea
            placeholder="Event Description*"
            value={eventData.description}
            name="description"
            onChange={handleInputChange}
            rows={4}
            style={{ marginBottom: "10px" }}
          />
          <Input
            placeholder="Referred Person Name"
            value={eventData.refferedPerson || ""} // Optional field
            name="refferedPerson"
            onChange={handleInputChange}
            rules={[
              {
                pattern: /^[A-Za-z\s]+$/,
                message: "Only letters and spaces are allowed",
              },
            ]}
            style={{ marginBottom: "10px" }}
          />
          <Typography.Text strong>Type of Occasion:</Typography.Text>
          <br />
          <Radio.Group
            name="eventType" // Add name attribute
            value={eventData.eventType}
            onChange={handleInputChange}
          >
            <Radio.Button value="Appointment">Appointment</Radio.Button>

            <Radio.Button value="SpecialDay">Special Day</Radio.Button>

            <Radio.Button value="Event">Event</Radio.Button>
          </Radio.Group>
          <br /> <br />
          <Typography.Text strong>Priority:</Typography.Text>
          <br />
          <Radio.Group
            name="priority" // Add name attribute
            value={eventData.priority}
            onChange={handleInputChange}
          >
            <Radio.Button value="important">Important</Radio.Button>
            <Radio.Button value="notImportant">Not Important</Radio.Button>
          </Radio.Group>
          <br /> <br />
          <Upload beforeUpload={() => false} onChange={handleImageUpload}>
            <Button icon={<UploadOutlined />}>Upload Image</Button>
          </Upload>
        </Modal>
      </div>
    </div>
  );
};

export default EventEntryPage;
